import React from "react";
import "./Skeleton.scss";

interface AIStatusProps {
    visible?: boolean;
    autoStart?: boolean;
}

export const Skeleton: React.FC = () => {
    return (
        <div className="card">
            <div className="skeleton skeleton-img"></div>
            <div className="card-content">
                <div className="skeleton skeleton-text"></div>
                <div className="skeleton skeleton-text"></div>
                <div className="skeleton skeleton-text skeleton-text-short"></div>
            </div>
        </div>

    );
};
